<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.displayName">

    <div class="text-right leading-tight hidden sm:block">
<!--      <p class="font-semibold">{{ current_user.name }}</p>-->
      <p class="font-semibold">{{ $store.getters.currentUser.first_name || '' }} {{ $store.getters.currentUser.last_name || '' }}</p>
      <small>{{ $store.getters.currentUser.role.name || $store.getters.currentUser.supplier.company_name }}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <img v-if="activeUserInfo.photoURL" key="onlineImg" :src="`https://ui-avatars.com/api/?name=${$store.getters.currentUser.first_name}+${$store.getters.currentUser.last_name}`" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <router-link to="/pages/user-settings">
            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
              <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Profile</span>
            </li>
          </router-link>

<!--          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">-->
<!--            <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />-->
<!--            <span class="ml-2">Inbox</span>-->
<!--          </li>-->

<!--          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">-->
<!--            <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />-->
<!--            <span class="ml-2">Tasks</span>-->
<!--          </li>-->

<!--          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">-->
<!--            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />-->
<!--            <span class="ml-2">Chat</span>-->
<!--          </li>-->

<!--          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">-->
<!--            <feather-icon icon="HeartIcon" svgClasses="w-4 h-4" />-->
<!--            <span class="ml-2">Wish List</span>-->
<!--          </li>-->

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logouts">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
  import {
    mapActions
  } from 'vuex'
  import store from '@/store/store.js'


  export default {
  data() {
      return {
        current_user : {}
      }
    },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  },

  methods: {
    ...mapActions(['logout']),
    async logouts () {
      localStorage.removeItem('userInfo')

      // This is just for demo Purpose. If user clicks on logout -> redirect
      // this.$router.push('/pages/login').catch(() => {})
      await this.logout()
    }
  },
    mounted() {
      this.current_user = store.getters.currentUser
    }
  }
</script>
